import React from 'react';
import { FaQuoteLeft } from 'react-icons/fa';
import StarRating from '../StarRating/StarRating';

const TestimonialCard = ({ testimonial }) => {
  const getInitials = (name) => {
    return name
      .split(' ')
      .map((word) => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-AU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <div className="card p-6 md:p-8 flex flex-col h-full">
      {/* Quote icon */}
      <FaQuoteLeft className="text-2xl text-primary-100 mb-4" />

      {/* Message */}
      <p className="text-gray-600 leading-relaxed mb-6 flex-grow">
        "{testimonial.message}"
      </p>

      {/* Rating */}
      <div className="mb-4">
        <StarRating rating={testimonial.rating} size="text-base" />
      </div>

      {/* Author */}
      <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
        <div className="w-11 h-11 bg-primary-500 rounded-full flex items-center justify-center flex-shrink-0">
          <span className="text-white font-semibold text-sm">
            {getInitials(testimonial.name)}
          </span>
        </div>
        <div>
          <h4 className="font-semibold text-gray-800 text-sm">{testimonial.name}</h4>
          {testimonial.createdAt && (
            <p className="text-xs text-gray-400">{formatDate(testimonial.createdAt)}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;